import { UserCatalogDto, UserDto } from '@/api/generator';
import { useTranslation } from 'i18next-vue';

export function useUserConstants() {
  const { t } = useTranslation();

  const systemUser: UserCatalogDto & UserDto = {
    id: NaN,
    userName: t('System'),
    lastName: '',
    emailAddress: '',
    fullName: t('System'),
    assignedRoles: [],
  };

  const ptwUser: UserCatalogDto & UserDto = {
    id: NaN,
    userName: t('Ptw'),
    lastName: '',
    emailAddress: '',
    fullName: t('Ptw'),
    assignedRoles: [],
  };

  return {
    systemUser,
    ptwUser,
  };
}
